import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Rect from '@bubble-ui/primitive-rect';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotCatalogComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotCatalog',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6CC6FF",
    d: "M19.287 18.568a1 1 0 0 1-.95.86l-9.14.368a1 1 0 0 1-1.03-1.138L9.832 6.807a1 1 0 0 1 .95-.86l9.14-.368a1 1 0 0 1 1.03 1.138l-1.665 11.851Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0076BE",
    d: "M20.022 20.524a1 1 0 0 1-1.13.851L8.99 19.983a1 1 0 0 1-.851-1.129l1.67-11.883a1 1 0 0 1 1.13-.851L20.84 7.51a1 1 0 0 1 .851 1.13l-1.67 11.883Z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 8,
    height: 3,
    x: 11.511,
    y: 9.23,
    fill: "#6CC6FF",
    rx: 1,
    transform: "rotate(8 11.511 9.23)"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6CC6FF",
    d: "M14.725 15.177a1 1 0 0 1-.676 1.088l-8.685 2.873a1 1 0 0 1-1.304-.81L2.395 6.478a1 1 0 0 1 .676-1.09l8.684-2.872a1 1 0 0 1 1.305.81l1.665 11.85Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0094EE",
    d: "M15.97 16.854a1 1 0 0 1-.85 1.13l-9.903 1.391a1 1 0 0 1-1.13-.85L2.418 6.64a1 1 0 0 1 .852-1.13L13.17 4.12a1 1 0 0 1 1.13.85l1.67 11.884Z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 8,
    height: 3,
    x: 4.676,
    y: 8.343,
    fill: "#6CC6FF",
    rx: 1,
    transform: "rotate(-8 4.676 8.343)"
  }));
};
SpotCatalogComponent.displayName = 'SpotCatalog';
export var SpotCatalog = withProvisionalOverrideFromContext(SpotCatalogComponent);
//# sourceMappingURL=index.js.map